import * as React from "react";
import { useState, useEffect, useRef } from "react";
import { Box, Typography, Button, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import GridViewIcon from "@mui/icons-material/GridView";
import { useParams } from "react-router-dom";
import VideoPlayer from "../components/VideoPlayer";
let profileInfo = require("../artistProfileInfo.js");

function ArtistProfileFull() {
    let params = useParams();
    let artistsData = profileInfo.getArtistProfileData();
    let artist = artistsData[params.artist];
    let [exiting, setExiting] = useState(false);
    let [profileVideoProgress, setProfileVideoProgress] = useState(0.0);

    const finalVideoProgress = useRef(profileVideoProgress);

    let navigate = useNavigate();

    //Delay to navigate back to artists after video finishes.
    const galleryDevice =  useMediaQuery('(min-width:3000px)');
    const exitDelay = galleryDevice ? 100 : false;

    useEffect(() => {
        window.gtag('event', 'page_view', {
            page_title: `${artist.name} Profile`,
            page_location: window.location.href,
            gallery_device: galleryDevice,
            send_to: 'G-PC1LP4S0D0'
        });
    },[artist.name, galleryDevice])

    useEffect(() => {
        finalVideoProgress.current = profileVideoProgress;
    }, [profileVideoProgress])    

    useEffect(() => {
        if (exiting) {
            setTimeout(() => {
                navigate("/artists", { state: "from profile" });
            }, 1400);
            return () => {
                window.gtag('event', 'video_view', {
                    video_title: `${artist.name}`,
                    video_completion: finalVideoProgress.current,
                    send_to: 'G-PC1LP4S0D0',
                    gallery_device: galleryDevice
                })
            }
        }
    }, [exiting, navigate, artist.name, galleryDevice]);

    return (
        <Box
            className="artist-profile"
            role="region"
            aria-label={`${artist.name} profile information and video.`}
            sx={{
                width: "100%",
                paddingLeft: "2.6vw",
                paddingTop: "6.81vh",
                paddingRight: "2.6vw",
                animation: exiting ? "fade-out 1.5s ease" : "",
                backgroundColor: "secondary.main"

            }}
        > 
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    columnGap: "min(60px, 1.5625vw)",
                }}
            >
                <Box
                    role="region"
                    aria-label="Artist Information"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "1.5vh",
                    }}
                >
                    <Box
                        role="img"
                        arial-label={`${artist.name} image`}
                        style={{
                            animation: "slide-right 1.5s backwards",
                            
                        }}
                        sx={{
                            background: `url(${artist.fullImage}) no-repeat`,
                            backgroundSize: "cover",
                            minHeight: "180px",
                            aspectRatio: "762/905"

                        }}
                    ></Box>
                    <Typography
                        component={"h1"}
                        style={{
                            animation: "slide-right 1.5s 0.3s backwards",
                        }}
                        sx={{
                            fontFamily: "GT Eesti Display Bold",
                            fontSize: "max(20px,3.241vh)",
                            lineHeight: "max(24px, 3.75vh)",
                            letterSpacing: "1.4px",
                            height: "auto",
                            color: "text.contrast"
                        }}
                    >
                        {artist.name}
                    </Typography>
                    <Typography
                        style={{
                            animation: "slide-right 1.5s 0.5s backwards",
                        }}
                        sx={{
                            fontFamily: "GT Eesti Display Regular Italic",
                            fontSize: artist.quote.length <= 360 ? "max(14px, 2.315vh)" : "max(14px, 1.9vh)",
                            lineHeight: "max(16px, 2.870vh)",
                            letterSpacing: "1px",
                            color: "text.contrast"
                        }}
                    >
                        {artist.quote}
                    </Typography>
                </Box>
                <Box
                    role="region"
                    aria-label="Profile Video"
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "3vh",

                    }}
                >
                    <VideoPlayer
                        vidStyle={{
                            animation: "fade-in 1.5s 1.5s backwards",
                            width: "73.33vw"
                        }}
                        vidSrc={artist.videos.mobile}
                        controls={galleryDevice}
                        setExiting={setExiting}
                        exitDelay={exitDelay}
                        mobile={false}
                        setProfileVideoProgress={setProfileVideoProgress}
                    />
            
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            marginLeft: "30%",
                            alignItems: "start",
                            animation: "fade-in 1.5s 1.5s backwards",
                            minWidth: "750px",
                            minHeight: "50px"
                        }}
                    >
                        <Button
                            variant="contained"
                            sx={{
                                height: "4.63vh",
                                minHeight: "50px",
                                borderRadius: "max(25px,2.3148vh)",
                                color: "text.darker",
                                fontSize: "max(18px, 1.389vh)",
                                lineHeight: "max(22px,1.620vh)",
                                letterSpacing: "0.1389vh",
                                fontFamily: "GT Eesti Display Bold",
                                aspectRatio: "402/100",
                                backgroundColor: "primary"
                            }}
                            onClick={() => {
                                setExiting(true);
                            }}
                        >
                            <GridViewIcon
                                style={{ fontSize: "max(30px, 3.7037vh)" }}
                                sx={{
                                    marginRight: "4%",
                                }}
                            />
                            All Artists
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default ArtistProfileFull;
